import React, { forwardRef } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import moment from 'moment';

const PrintableLACERiskTable = forwardRef(({ data }, ref) => {
  const tableData = data || [];
  const columns = [
    {
      dataField: "patientName",
      text: "Patient Name",
      formatter: (cell) => cell || "-",
    },
    {
      dataField: "organization",
      text: "Organization",
      formatter: (cell) => cell || "-",
    },
    {
      dataField: "lastEntry.createdByName",
      text: "Created by",
      formatter: (cell) => cell || "-",
    },
    {
      dataField: "lastEntry.totalScore",
      text: "Last LACE Score",
      formatter: (cell) => {
        if (!cell && cell !== 0) return <p>-</p>;
        let risk = '';
        let badgeStyle = {};
        if (cell <= 4) {
          risk = 'Low';
          badgeStyle = { backgroundColor: '#28a745', color: '#fff' };
        } else if (cell <= 9) {
          risk = 'Moderate';
          badgeStyle = { backgroundColor: '#ffc107', color: '#212529' };
        } else {
          risk = 'High';
          badgeStyle = { backgroundColor: '#dc3545', color: '#fff' };
        }
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <p style={{ margin: 0, fontWeight: 'bold' }}>{cell}</p>
            <span
              style={{
                ...badgeStyle,
                padding: '4px 8px',
                borderRadius: '12px',
                fontSize: '0.75rem',
                fontWeight: 'bold',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                border: '1px solid rgba(255,255,255,0.2)'
              }}
            >
              {risk}
            </span>
          </div>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: '15%', textAlign: 'left' };
      },
    },
    {
      dataField: "lastEntry.createdAt",
      text: "Created Date",
      formatter: (cell) => cell ? moment(cell).format("MMMM DD, YYYY hh:mm A") : "-",
    },
    {
      dataField: "lastEntry.lastModifyByName",
      text: "Last LACE Risk Updated By",
      formatter: (cell, row) => {
        if (cell) {
          return `${cell} (${row.lastEntry && row.lastEntry.modifyDate ? moment(row.lastEntry.modifyDate).format("MMMM DD, YYYY hh:mm A") : "-"})`;
        } else {
          return cell || "-";
        }
      },
    },
  ];

  return (
    <div ref={ref} style={{ padding: '20px', fontFamily: 'Arial, sans-serif', maxWidth: '1200px', margin: '0 auto' }}>
      <style>
        {`
          @media print {
            .table-hover tbody tr:hover {
              background-color: transparent !important;
            }
            body, .table {
              font-size: 12px;
            }
            h2 {
              font-size: 24px;
              color: black !important;
            }
            p {
              font-size: 12px;
              color: black !important;
            }
            .table th, .table td {
              padding: 8px;
            }
            .badge {
              border: 1px solid #000;
            }
          }
        `}
      </style>
      <h2 style={{
        color: '#2c3e50',
        marginBottom: '15px',
        fontSize: '28px',
        fontWeight: 'bold',
        textAlign: 'center',
        borderBottom: '2px solid #3498db',
        paddingBottom: '10px'
      }}>LACE Risk Score Report</h2>
      <p style={{
        color: '#7f8c8d',
        marginBottom: '30px',
        fontSize: '14px',
        textAlign: 'center',
        fontStyle: 'italic'
      }}>Generated on: {moment().format("MMMM DD, YYYY hh:mm A")}</p>
      <BootstrapTable
        keyField="_id"
        data={tableData}
        columns={columns}
        bordered
        striped
        hover
        wrapperClasses="table-responsive"
        classes="table table-bordered table-striped table-hover"
        headerClasses="thead-dark"
      />
    </div>
  );
});

export default PrintableLACERiskTable;